<iframe *ngIf="service" id="service-iframe" (load)="loaded()" [src]="service.url | safe"></iframe>
